import { T } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'
import * as _ from 'lodash'

import Persistance from "../Persistence";
//import { InputField } from './InputField'

import { Exit } from '../../Components/Icons'
//import { InputSwitch } from 'primereact/inputswitch'
//import { Calendar } from 'primereact/calendar'
//import { HorizontalLine } from '../Common/HorizonalLine'
import SDKFactory from '../../Components/SDKFactory'
import HorizontalLine from '../Common/HorizonalLine'
import { Caret } from '../../Components/Icons'
import { Calendar } from 'primereact/calendar'

interface Form {
    [key: string]: string
}

export interface Props {
    children?: React.ReactNode
    inPlaceUpdate: () => void
    closeForm: () => void
    scheduele: T.Schedule
    date: string
}

export interface State {
    expandExpenses: boolean
    expandNotes: boolean
    form: Form
    errors: { [key: string]: string }
    deleteType: string
    showDeleteMenu: boolean
    start_date: string
    end_date: string
    verify: boolean
}

Persistance.setValues()

export class EditScheduleForm extends React.Component<Props, any> {
    private sdk = SDKFactory.getScheduleSDK()
    private wrapperRef = React.createRef<HTMLInputElement>();

    public constructor(props: Props) {
        super(props)

        let form = {
            exception_start_date: this.props.date
        }

        this.state = {
            expandExpenses: false,
            expandNotes: false,
            form: form,
            deleteType: null,
            showDeleteMenu: false,
            start_date: this.props.date,
            end_date: this.props.date,
            verify: false
        }

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event: any) {
        if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
            if (this.state.showDeleteMenu) {
                this.setState({ showDeleteMenu: false })
            }
        }
    }



    public deleteEvent = () => {

        /*let errors = this.verifyAddForm()

        if (Object.keys(errors).length !== 0) {
            this.setState({ errors: errors })
            console.log('these are my errors', this.state.errors)
            return
        }

        let formData = this.state.form*/
        this.prepEvent()

    }
    public verify = () => {
        const { start_date, end_date, deleteType } = this.state
        let errors: any = {}

        if  (deleteType === 'RANDEL'){

            let start = m(start_date)
            let end = m(end_date)
            
            if (!start.isValid()) errors['startTime'] = 'Start time is required'
            if (!end.isValid()) errors['endTime'] = 'End Time is required'
            if (end.isBefore(start, 'minutes')) errors['end_date'] = 'End date can not be before start date'
        }
        
        return errors
    }

    public prepEvent = async () => {

        let form = this.props.scheduele
        let id = this.props.scheduele.id ? this.props.scheduele.id.toString() : ''
        
        delete form.created_at
        delete form.updated_at

        let data: T.Schedule = {
            ...form,
            exception_type: this.state.deleteType,
            exception_start_date: this.props.date,
            exception_end_date: this.props.date
        }

        switch (this.state.deleteType) {
                            case 'FUTDEL':
                                data.exception_end_date = m(this.props.date).format('YYYY-MM-DD')
                                break
                            case 'RANDEL':
                                data.exception_start_date = this.state.start_date
                                data.exception_end_date = this.state.end_date
                                break    
                        }
        
        

        await this.deleteScheduleEvent(id, data)
    }


    public deleteScheduleEvent = async (id: string, data: T.Schedule) => {
        try {

            const res = await this.sdk.deleteSchedule(id, data)

            let sche = res.data
            const hasError: boolean = _.get(sche, 'errors', false) as boolean

            if (!hasError && res.status === 'success') {
                //let data = sche as T.ScheduleDay[]
                this.props.inPlaceUpdate()
                this.props.closeForm()
                this.setState({verify: false})
            }
        } catch (reason) {
            console.log('Error saving schedule event', reason)
        }
    }

    public toggleMenu = () => {
        this.setState({ showDeleteMenu: !this.state.showDeleteMenu })
    }

    public setDeleteType = (type: string) => {
        this.setState({ deleteType: type, showDeleteMenu: false, verify: false })
    }

    public setDatePickerFormInfo = (key: string, e: any) => {
        let date = m(e.target.value).format('YYYY-MM-DD')
       this.setState({[key]: date, verify: false}) 
    }

    public renderVerification = () => {
        return (
            <div className='w-full'>
                <div className='w-full rounded-lg p-2 my-4 bg-gray-200 text-silver-200'>
                    <span className='text-xl font-bold'>Confirm Delete</span>
                    <div className='w-full text-sm'>
                        Are you sure you want to delete this event? This action is immediate and can not be undone.
                    </div>
                </div>
                <div className='grid grid-cols-2 gap-2 w-full items-center'>
                     <button 
                        onClick={() => this.setState({verify: false})}
                        className='p-1 rounded-md text-white bg-slate-400 hover:bg-slate-600 hover:text-white text-sm' type='button'>
                        No, Cancel
                     </button>
                     <button 
                        onClick={() => this.deleteEvent()}
                        className='p-2 rounded-md text-slate-200 bg-red-500  hover:bg-red-800 hover:text-slate-200 text-lg' type='button'>
                        Yes, Delete
                     </button>
                    </div>
            </div>
        )
    }

    public render(): React.ReactNode {

        const { scheduele, date } = this.props

        let deleteMenuLabel = 'Select Deletion Type'

        if (this.state.deleteType !== null && !this.state.showDeleteMenu) {
            switch (this.state.deleteType) {
                case 'ALLDEL':
                    deleteMenuLabel = 'Delete All Occurances of event'
                    break
                case 'SINGDEL':
                    deleteMenuLabel = 'Delete Single Occurance of event'
                    break
                case 'FUTDEL':
                    deleteMenuLabel = 'Delete All Future Occurances of event'
                    break
                case 'RANDEL':
                    deleteMenuLabel = 'Delete Occurances of event in range'
                    break
            }
        }


        return (
            <div className='w-120 flex flex-col'>
                <div className='w-full flex flew-row items-center pb-2'>
                    <h2 className='w-auto grow text-left text-sm font-semibold text-gray-600'>Delete this event?</h2>
                    <div onClick={() => this.props.closeForm()} className='w-auto flex-none text-right justify-items-end hover:cursor-pointer'>
                        <Exit size='small' />
                    </div>
                </div>

                <form noValidate className="space-y-4 md:space-y-6">
                    <div className='w-full flex flex-col'>
                        <div className='w-full flex flex-row items-center'>
                            <div className='w-full'>
                                <div className='py-4 flex flex-col'>
                                    <div className='w-full text-xl font-semibold text-stone-900'>
                                        {scheduele.name}
                                    </div>
                                    <div className='w-full text-md font-mediun text-color text-stone-700'>
                                        {m(date).format('ddd MMM DD, YYYY')}
                                    </div>
                                    <div ref={this.wrapperRef} className='w-full py-2'>
                                        <div className='w-full'>
                                            <button
                                                className='w-full inline-block text-left px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white'
                                                onClick={() => this.setState({ showDeleteMenu: !this.state.showDeleteMenu })}
                                                type="button">
                                                <div className='w-full flex flex-row items-center'>
                                                    <div className='flex-grow'>{deleteMenuLabel}</div>
                                                    <div className='none rotate-180'><Caret size='small' /></div>
                                                </div>
                                            </button>
                                        </div>
                                        {this.state.showDeleteMenu && <ul className="absolute z-10 mt-1 w-content origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden">
                                            <li>
                                                <button type='button' onClick={() => this.setDeleteType('ALLDEL')} className="block text-left w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Delete All Occurances of event</button>
                                            </li>
                                            <li>
                                                <button type='button' onClick={() => this.setDeleteType('SINGDEL')} className="block text-left  w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Delete Single Occurance of event</button>
                                            </li>
                                            <li>
                                                <button type='button' onClick={() => this.setDeleteType('FUTDEL')} className="block text-left  w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Delete All Future Occurances of event</button>
                                            </li>
                                            <li>
                                                <button type='button' onClick={() => this.setDeleteType('RANDEL')} className="block text-left  w-full text-slate-800 p-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">Delete Occurances of event in range</button>
                                            </li>
                                        </ul>}
                                    </div>
                                    {this.state.deleteType === 'RANDEL' && (
                                        <div className='w-full grid grid-cols-2 gap-2 py-2'>
                                        <div className='grid-span-full sm:grid-span-1'> 
                                            <div className=' text-small text-gray-800'>
                                                Start Date
                                            </div>
                                            <div className='bg-gray-50 border-2 text-gray-900 text-m focus:ring-1 focus:ring-gray-100 focus:border-0 grid-span-1 p-2.5 placeholder:text-gray-500 placeholder:text-center'>
                                                <Calendar
                                                    className='w-full'
                                                    p-inputtext='flex-grow bg-gray-50 rounded-lg'
                                                    p-calendar='bg-gray-50 rounded-lg'
                                                    value={m(this.state.start_date).toDate()} onChange={(e) => this.setDatePickerFormInfo('start_date', e)} showIcon />
                                            </div>
                                        </div>
                                        <div className='grid-span-full sm:grid-span-1'> 
                                            <div className=' text-small text-gray-800'>
                                            End Date
                                            </div>
                                            
                                            <div className='bg-gray-50 border-2 text-gray-900 text-m focus:ring-1 focus:ring-gray-100 focus:border-0 grid-span-1 p-2.5 placeholder:text-gray-500 placeholder:text-center'>
                                                <Calendar
                                                    className='w-full'
                                                    p-inputtext='flex-grow bg-gray-50 rounded-lg'
                                                    p-calendar='bg-gray-50 rounded-lg'
                                                    value={m(this.state.end_date).toDate()} onChange={(e) => this.setDatePickerFormInfo('end_date', e)} showIcon />
                                            </div>
                                        </div>    
                                        </div>
                                    )}

                                </div>
                                <div className='w-full'>
                                    <HorizontalLine
                                        color='#999999'
                                        size='1px'
                                        padding='3.5em' />
                                </div>
                                {!this.state.verify && <div className='py-4 grid grid-flow-col justify-items-end'>
                                    <button
                                        onClick={() => this.setState({verify: true})}
                                        type="button"
                                        className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                        Delete Event
                                    </button>
                                </div>}
                                {this.state.verify && this.renderVerification()}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

}

export default EditScheduleForm